import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';

import { getChangelogsByLanguage } from '@/assets/changelogs';

import { useUser } from '../../application/context/user';
import { FeatureFlag, LanguageCode } from '../../types';
import { ChangelogItem } from './ChangelogItem';

export const ChangelogList = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const isChangelogsEnabled = useFeatureFlagEnabled(FeatureFlag.CHANGELOGS);
  const allChangelogs = getChangelogsByLanguage({ language: user?.language ?? LanguageCode.EN });
  const changelogs = isChangelogsEnabled
    ? allChangelogs
    : allChangelogs.filter((c) => c.slug === 'welcome-to-mavue');
  if (changelogs.length === 0) {
    return (
      <div className="text-center py-12 px-6 bg-muted/30 rounded-lg border border-border/50">
        <p className="text-muted-foreground text-sm">
          {t('modules.mavue2.notificationDialog.emptyState.noUpdates')}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {changelogs.map((changelog) => (
        <ChangelogItem key={changelog.slug} changelog={changelog} />
      ))}
    </div>
  );
};
